import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A group of components that can be put together to create a hierarchy of panels that can be revealed and hidden.
 *
 * View the code of the examples to see how to structure the various elements involved.
 */
export const Disclosure = ({ children, as: Tag = 'div', ...rest }) => {
    return (_jsx(Tag, { ...rest, "data-testid": "Disclosure", children: children }));
};
//# sourceMappingURL=disclosure.js.map